var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuItemPolicyInquiry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.47 6.345l-5.176-5.156A.649.649 0 0014.837 1H5.78A1.94 1.94 0 003.84 2.934v18.132A1.94 1.94 0 005.78 23h12.938a1.94 1.94 0 001.94-1.934V6.801a.65.65 0 00-.189-.456zm-4.986-3.144l2.966 2.955h-2.32a.646.646 0 01-.646-.644V3.2zm3.234 18.51H5.781a.646.646 0 01-.647-.645V2.934c0-.356.29-.645.647-.645h8.409v3.223a1.94 1.94 0 001.94 1.933h3.235v13.621c0 .356-.29.645-.647.645z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.13 10.11H8.369a.646.646 0 100 1.288h7.763a.646.646 0 100-1.289zM16.13 12.688H8.369a.646.646 0 100 1.289h7.763a.646.646 0 100-1.29zM16.13 15.266H8.369a.646.646 0 100 1.289h7.763a.646.646 0 100-1.29zM13.543 17.844H8.368a.646.646 0 100 1.289h5.175a.646.646 0 100-1.29z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconMenuItemPolicyInquiry;